/**
 * ---------------------------------------------------------------------------
 * Bellavista — case types gefilterd op telefoonmodel
 * ---------------------------------------------------------------------------
 * 1. De modelkiezer start leeg ("Choose your model"). Zolang er geen model
 *    gekozen is, blijven alle 4 de case types zichtbaar en staat Add to cart uit.
 * 2. Zodra er een model gekozen is, blijven enkel de case types staan die voor
 *    dat model bestaan. Zo kan niemand nog MagSafe bij een Android-toestel kiezen.
 * 3. Stond er een case type aangeduid dat niet bestaat voor het nieuwe model,
 *    dan springt de selectie automatisch naar het eerste dat wel bestaat.
 *
 * Werkt op basis van de data-option-position attributen van het thema:
 * positie 1 = Model, positie 2 = Case type. Enkel producten met exact twee
 * opties worden aangeraakt, en de lege startstaat enkel als optie 1 "Model" heet.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var TEXT_PLACEHOLDER = 'Choose your model';
  var TEXT_PICK_FIRST = 'Choose your model first';

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  // Het thema zet geen optienamen in de product-JSON, dus het aantal opties
  // komt uit de varianten zelf.
  function optionCount(product) {
    var variant = product.variants[0] || {};
    if (variant.options && variant.options.length) return variant.options.length;
    if (variant.option3 != null) return 3;
    if (variant.option2 != null) return 2;
    return 1;
  }

  function rootFor(jsonElement) {
    var node = jsonElement.parentElement;
    while (node && node !== document.body) {
      if (node.querySelector('.Product__Block--variantPicker')) return node;
      node = node.parentElement;
    }
    return null;
  }

  function Picker(root, product) {
    this.root = root;
    this.product = product;
    this.map = {};
    this.pending = null;
    this.placeholderDone = false;

    var map = this.map;
    product.variants.forEach(function (variant) {
      var model = variant.option1;
      if (!map[model]) map[model] = [];
      if (map[model].indexOf(variant.option2) === -1) map[model].push(variant.option2);
    });

    this.isModelProduct = this.firstOptionName().toLowerCase() === 'model';

    var price = root.querySelector('.Product__PriceList');
    this.priceHTML = price ? price.innerHTML : null;

    this.init();
  }

  Picker.prototype.block = function () {
    return this.root.querySelector('.Product__Block--variantPicker') || this.root;
  };

  Picker.prototype.modelSelect = function () {
    var option = this.root.querySelector('option[data-option-position="1"]');
    return option ? option.closest('select') : null;
  };

  Picker.prototype.caseSelect = function () {
    var option = this.root.querySelector('option[data-option-position="2"]');
    return option ? option.closest('select') : null;
  };

  Picker.prototype.caseRadios = function () {
    return toArray(this.root.querySelectorAll('input[type="radio"][data-option-position="2"]'));
  };

  // Naam van optie 1, uit de naam van het veld of anders uit het label ernaast.
  Picker.prototype.firstOptionName = function () {
    var select = this.modelSelect();
    var control = select || this.root.querySelector('input[type="radio"][data-option-position="1"]');
    if (!control) return '';

    var match = /\[([^\]]+)\]/.exec(control.name || '');
    if (match) return match[1].trim();

    var wrapper = control.closest('.ProductForm__Option');
    var label = wrapper && wrapper.querySelector('.ProductForm__Label, label');
    return label ? label.textContent.split(':')[0].trim() : '';
  };

  Picker.prototype.modelValue = function () {
    var select = this.modelSelect();
    if (select) return select.value;
    var checked = this.root.querySelector('input[type="radio"][data-option-position="1"]:checked');
    return checked ? checked.value : '';
  };

  Picker.prototype.init = function () {
    var self = this;

    this.root.addEventListener('change', function () {
      self.schedule();
    }, false);

    // Het thema herrendert het hele variant-picker blok na elke wijziging,
    // dus na zo'n vervanging moet het filter opnieuw toegepast worden.
    new MutationObserver(function () {
      self.schedule();
    }).observe(this.block(), { childList: true, subtree: true });

    this.addPlaceholder();
    this.apply();
  };

  Picker.prototype.schedule = function () {
    var self = this;
    if (this.pending) return;
    this.pending = setTimeout(function () {
      self.pending = null;
      self.apply();
    }, 0);
  };

  Picker.prototype.addPlaceholder = function () {
    if (!this.isModelProduct || this.placeholderDone) return;

    var select = this.modelSelect();
    if (!select) return;

    this.placeholderDone = true;

    // Deel-link naar een specifieke variant: die keuze respecteren.
    if (window.location.search.indexOf('variant=') > -1) return;
    if (select.querySelector('option[data-bv-placeholder]')) return;

    var option = document.createElement('option');
    option.value = '';
    option.textContent = TEXT_PLACEHOLDER;
    option.setAttribute('data-option-position', '1');
    option.setAttribute('data-bv-placeholder', '');
    select.insertBefore(option, select.firstChild);
    select.value = '';
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  Picker.prototype.apply = function () {
    var model = this.modelValue();
    var allowed = model ? this.map[model] : null;

    var radios = this.caseRadios();
    var caseSelect = this.caseSelect();

    if (radios.length) {
      var firstRadio = null;
      var switchRadio = false;

      radios.forEach(function (input) {
        var wrapper = input.closest('li') || input.parentElement;
        var ok = !allowed || allowed.indexOf(input.value) > -1;
        if (wrapper) {
          var display = ok ? '' : 'none';
          if (wrapper.style.display !== display) wrapper.style.display = display;
        }
        if (ok && !firstRadio) firstRadio = input;
        if (!ok && input.checked) switchRadio = true;
      });

      if (switchRadio && firstRadio) {
        firstRadio.checked = true;
        firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (caseSelect) {
      var firstOption = null;
      var switchOption = false;

      toArray(caseSelect.options).forEach(function (option) {
        var ok = !allowed || allowed.indexOf(option.value) > -1;
        option.hidden = !ok;
        option.disabled = !ok;
        if (ok && !firstOption) firstOption = option;
        if (!ok && option.selected) switchOption = true;
      });

      if (switchOption && firstOption) {
        caseSelect.value = firstOption.value;
        caseSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (this.isModelProduct) this.reflectEmptyModel(model === '');
  };

  Picker.prototype.reflectEmptyModel = function (empty) {
    var button = this.root.querySelector('.ProductForm__AddToCart');
    var dynamic = this.root.querySelector('.shopify-payment-button');
    var price = this.root.querySelector('.Product__PriceList');

    this.root.setAttribute('data-bv-model-empty', empty ? 'true' : 'false');

    if (empty) {
      // Zelf blokkeren, los van wat het thema denkt: zonder model geen bestelling.
      if (button) {
        button.setAttribute('disabled', 'disabled');
        button.removeAttribute('data-action');
        if (button.textContent.trim() !== TEXT_PICK_FIRST) {
          button.innerHTML = '<span>' + TEXT_PICK_FIRST + '</span>';
        }
      }
      if (dynamic) dynamic.style.display = 'none';
      // Het thema wist de prijs zodra er geen variant is; die zetten we terug.
      if (price && this.priceHTML && !price.innerHTML.trim()) price.innerHTML = this.priceHTML;
    } else if (dynamic && dynamic.style.display === 'none') {
      dynamic.style.display = '';
    }
  };

  function scan() {
    toArray(document.querySelectorAll('[data-product-json]')).forEach(function (jsonElement) {
      if (jsonElement.getAttribute('data-bv-filter')) return;

      var data;
      try {
        data = JSON.parse(jsonElement.innerHTML);
      } catch (error) {
        jsonElement.setAttribute('data-bv-filter', 'skip');
        return;
      }

      var product = data && data.product;
      var root = rootFor(jsonElement);

      jsonElement.setAttribute('data-bv-filter', '1');

      if (!root) return;
      if (!product || !product.id || !product.variants || !product.variants.length) return;
      if (optionCount(product) !== 2) return;

      new Picker(root, product);
    });
  }

  var rescan = null;
  function scheduleScan() {
    if (rescan) return;
    rescan = setTimeout(function () {
      rescan = null;
      scan();
    }, 200);
  }

  function start() {
    scan();
    // Quickview en het theme-editor herladen secties dynamisch.
    new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', scheduleScan);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
